import React, { useState } from "react";
import { IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ConfirmDialog from "../ConfirmDialog";
import { useNavigate } from "react-router-dom";
import ChangesHistory from "../History";
import { ACCOUNT_REMOVAL_TITLE, ACCOUNT_REMOVAL_MESSAGE } from "../../utils/accountRemoval";

const TableButtons = ({
  link,
  handleEdit,
  handleDelete,
  deletePopupEntity,
  historyData,
  allowEdit = true,
  extraButtons = [],
}) => {
  const navigate = useNavigate();

  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const handleEditClick = () => {
    if (link) {
      navigate(link);
    } else {
      handleEdit();
    }
  };

  return (
    <>
      <ConfirmDialog
        title={deletePopupEntity === "account" ? ACCOUNT_REMOVAL_TITLE : `Delete ${deletePopupEntity}?`}
        open={isOpenDelete}
        setOpen={setIsOpenDelete}
        onConfirm={handleDelete}
      >
        {deletePopupEntity === "account" ? ACCOUNT_REMOVAL_MESSAGE : `Are you sure you want to delete this ${deletePopupEntity}?`}
      </ConfirmDialog>

      {allowEdit && (
        <IconButton onClick={handleEditClick}>
          <EditOutlinedIcon />
        </IconButton>
      )}
      <ChangesHistory historyData={historyData} />
      {handleDelete && (
        <IconButton
          onClick={() => {
            setIsOpenDelete(true);
          }}
        >
          <DeleteForeverOutlinedIcon />
        </IconButton>
      )}
      {extraButtons}
    </>
  );
};

export default TableButtons;
